import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  model,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FileSizePipe, FileToUrlPipe } from '@core-utils';
import { KeeniconComponent } from '../../partials';
import { ButtonComponent } from '../../misc/button/button.component';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-form-upload-image',
  imports: [
    KeeniconComponent,
    ButtonComponent,
    TranslocoDirective,
    FileSizePipe,
  ],
  templateUrl: './form-upload-image.component.html',
  styleUrl: './form-upload-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
})
export class FormUploadImageComponent {
  file = model<File | null>(null);
  imageUrl = input<string | null>(null);
  idInput = input<string>('load-file');
  description = input<string>('');
  fileChanged = output<File | null>();

  isDragOver = signal(false);

  private readonly fileInput =
    viewChild.required<ElementRef<HTMLInputElement>>('fileInput');
  private readonly fileToUrl = new FileToUrlPipe();

  protected readonly previewUrl = computed(() => {
    const file = this.file();

    return file ? this.fileToUrl.transform(file) : this.imageUrl();
  });

  openPicker() {
    this.fileInput().nativeElement.click();
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (file) {
      this.setFile(file);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver.set(true);
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver.set(false);
    const file = event.dataTransfer?.files?.[0];
    if (file?.type.startsWith('image/')) {
      this.setFile(file);
    }
  }

  removeImage() {
    this.file.set(null);
    this.fileChanged.emit(null);
  }

  private setFile(file: File) {
    this.file.set(file);
    this.fileChanged.emit(file);
  }
}
